module.exports = __webpack_public_path__ + "static/media/success_filled.92a18304.svg";